export default __webpack_public_path__ + "static/img8-0d8c3c996ea71597a7636a84fd512654.jpg";